import { msg } from "../locales/translate";
import { IAcquirerChannel, ITerminal } from "src/types/types";
import { GD } from "../GD";
import { BanksService } from "./BanksService";

export class MerchantService {
	// merchants: DataProvider<{ projectID: number }, IMerchantModel[]> =
	// 	new DataProvider({ cacheTime: 0 }, "Merchants");

	constructor() {
		// this.merchants.setExecutor(
		// 	async _ =>
		// 		(await GD.REQ_API.request({
		// 			method: "merchant/list",
		// 			data: {
		// 			},
		// 		})) as IExecutorResponse<IMerchant[]>
		// );
		GD.REQ_MERCHANT.listener = async req => this.getMerchant(req);
		GD.REQ_MERCHANT_SAVE.listener = async req => this.saveMerchant(req);
		GD.REQ_MERCHANT_SETTINGS_GET.listener = async req => this.getMerchantSettings(req);
		GD.REQ_MERCHANT_SETTINGS_SET.listener = async req => this.setMerchantSettings(req);

		GD.REQ_MERCHANT_AQUIRERS.listener = async req => this.getMerchantAquirers(req);

		//GD.REQ_MERCHANT_AQUIRER_CHANNELS.listener = async req => this.getMerchantAquirerChannels(req);

		GD.REQ_MERCHANT_CHANNEL.listener = async req => this.getMerchantChannel(req);
		GD.REQ_MERCHANT_TERMINAL.listener = async req => this.getMerchantTerminal(req);

		GD.REQ_MERCHANT_ADD_CHANNEL.listener = async req => this.setMerchantAquirerChannel(req);

		GD.REQ_MERCHANT_REMOVE_CHANNEL.listener = async req => this.removeMerchantAquirerChannel(req);
		GD.REQ_MERCHANT_REMOVE.listener = async req => this.removeMerchant(req);

		GD.REQ_MERCHANT_REMOVE_TERMINAL.listener = async req => this.removeMerchantAquirerTerminal(req);
		GD.REQ_MERCHANT_RESTORE_TERMINAL.listener = async req => this.restoreMerchantAquirerTerminal(req);
		GD.REQ_MERCHANT_ATTACHED_CHANNELS.listener = async req => this.getMerchantChannels(req);

		// GD.B_MERCHANT_ATTACHED_CHANNELS.onRequest(async req => {
		// 	//!TODO: cache? move to separate data providers?

		// 	if (req) {
		// 		this.updateMerchantChannels(req);
		// 	}
		// });

		GD.B_MERCHANT_ATTACHED_TERMINALS.onRequest(async req => {
			//!TODO: cache? move to separate data providers?

			if (req) {
				this.updateMerchantTerminals(req);
			}
		});
	}

	async getMerchantChannels(req: { merchantID: number; terminalId?: number }): Promise<IAPIResponse<IAcquirerChannel[]>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		const res = await this.getAttachedMerchantAquirerChannels({
			merchantID: req.merchantID,
			terminalId: req.terminalId,
		});

		return res;
	}

	async saveMerchant(req: IMerchantModel): Promise<IAPIResponse<IMerchantModel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };

		let res: IAPIResponse = { error: { code: -1, message: msg("noData") } };

		//!TODO:;
		res = await GD.REQ_API.request({
			method: "merchants/add",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				id: req.id,
				client_id: req.client_id,
				name: req.name,
				description: req.description,
				terminal_id: req.terminal_id,
				group_id: req.group_id,
			},
		});
		// if (res && !res.error) {
		// 	this.clients.reset();
		// 		GD.B_CLIENTS.invoke(await this.clients.load());
		// }
		return res;
	}

	// async updateMerchantChannels(req: { merchantID: number; terminalId?: number }) {
	// 	if (req) {
	// 		const res = await this.getAttachedMerchantAquirerChannels({
	// 			merchantID: req.merchantID,
	// 			terminalId: req.terminalId,
	// 		});

	// 		GD.B_MERCHANT_ATTACHED_CHANNELS.invoke(res);
	// 	}
	// }

	async updateMerchantTerminals(req: { merchantID: number }) {
		if (req) {
			const res = await this.getAttachedMerchantTerminals({
				merchantID: req.merchantID,
			});

			GD.B_MERCHANT_ATTACHED_TERMINALS.invoke(res);
		}
	}

	async getAttachedMerchantAquirerChannels(req: { merchantID: number; terminalId?: number }): Promise<IAPIResponse<IAcquirerChannel[]>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const merchantSettings = await GD.REQ_API.request({
			method: "merchants/channels/get",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
				terminal_id: req.terminalId,
			},
		});

		return merchantSettings;
	}

	async getAttachedMerchantTerminals(req: { merchantID: number }): Promise<IAPIResponse<ITerminal[]>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const terminals = await GD.REQ_API.request({
			method: "merchants/terminals/list",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
			},
		});

		return terminals;
	}

	async setMerchantAquirerChannel(req: { merchantID: number; channelID: number }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const channelAdd = await GD.REQ_API.request({
			method: "merchants/channels/set",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				id: req.channelID,
				merchant_id: req.merchantID,
				channel_id: req.channelID,
			},
		});

		// if (channelAdd.data) {
		// 	this.updateMerchantChannels({
		// 		merchantID: req.merchantID,
		// 	});
		// }

		return channelAdd;
	}

	async removeMerchantAquirerChannel(req: { merchantID: number; channelID: number }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const channelAdd = await GD.REQ_API.request({
			method: "merchants/channels/remove",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				id: req.channelID,
				merchant_id: req.merchantID,
				channel_id: req.channelID,
			},
		});

		// if (channelAdd.data) {
		// 	this.updateMerchantChannels({
		// 		merchantID: req.merchantID,
		// 	});
		// }

		return channelAdd;
	}

	async removeMerchant(req: { merchantID: number }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const removeMerchant = await GD.REQ_API.request({
			method: "merchants/delete",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
			},
		});

		return removeMerchant;
	}

	async restoreMerchantAquirerTerminal(req: { merchantID: number; terminalID: number[] }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const terminalRestore = await GD.REQ_API.request({
			method: "merchants/terminals/set",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
				terminal_id: req.terminalID,
			},
		});

		if (terminalRestore.data) {
			this.updateMerchantTerminals({
				merchantID: req.merchantID,
			});
		}

		return terminalRestore;
	}

	async removeMerchantAquirerTerminal(req: { merchantID: number; terminalID: number }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const terminalRemove = await GD.REQ_API.request({
			method: "merchants/terminals/delete",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
				terminal_id: [req.terminalID],
			},
		});

		if (terminalRemove.data) {
			this.updateMerchantTerminals({
				merchantID: req.merchantID,
			});
		}

		return terminalRemove;
	}

	async getMerchantTerminal(req: { terminalLinkID: number; merchantID: number }): Promise<IAPIResponse<ITerminal>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const terminal = await GD.REQ_API.request({
			method: "merchants/terminals/get",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
				link_id: req.terminalLinkID,
			},
		});

		return terminal;
	}

	async getMerchantChannel(req: { channelId: number; merchantId?: number }): Promise<IAPIResponse<IAcquirerChannel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantId;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const channel = await GD.REQ_API.request({
			method: "merchants/channels/get",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantId,
				id: req.channelId,
			},
		});

		return channel;
	}

	async removeMerchantChannel(req: { channelId: number; merchantId?: number }): Promise<IAPIResponse<IAcquirerChannel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantId;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const channel = await GD.REQ_API.request({
			method: "merchants/channels/remove",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantId,
				channel_id: req.channelId,
			},
		});

		return channel;
	}

	// async getMerchantAquirerChannels(req: { merchantID: number; acquirerID: number }): Promise<IAPIResponse<IAcquirer>> {
	// 	if (!req) return { error: { code: -1, message: "Invalid request" } };
	// 	const merchantID = req.merchantID;

	// 	if (!merchantID) return { error: { code: -1, message: "Invalid merchant UID" } };

	// 	//!TODO: cache?;

	// 	const channels = await GD.REQ_API.request({
	// 		url: API_URL + "acquirers/get",
	// 		method: "" as IAPIMethod,
	// 		headers: { Authorization: "Basic " + BanksService.ssid },
	// 		data: {
	// 			merchant_id: req.merchantID,
	// 			id: req.acquirerID,
	// 		},
	// 	});

	// 	return channels;
	// }

	async getMerchantAquirers(req: { merchantID?: number }): Promise<IAPIResponse<IAcquirer[]>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const merchantAuqiurers = await GD.REQ_API.request({
			method: "acquirers/list",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				merchant_id: req.merchantID,
			},
		});

		return merchantAuqiurers;
	}

	async getMerchantSettings(req: { merchantID?: number; type?: "credentials" }): Promise<IAPIResponse<IMerchantSettings>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		//!TODO: cache?;

		const merchantSettings = await GD.REQ_API.request({
			method: "settings/get",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.merchantID,
				target_type: "merchant",
				...(req.type ? { type: req.type } : {}),
				// id:-1
			},
		});

		return merchantSettings;
	}

	async setMerchantSettings(req: { merchantID?: number; settings: ISettingsData; id: number }): Promise<IAPIResponse<boolean>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (!merchantID) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		const merchantSettingsSave = await GD.REQ_API.request({
			method: "settings/set",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: {
				target_id: req.merchantID,
				id: req.id,
				target_type: "merchant",
				data: req.settings,
			},
		});

		return merchantSettingsSave;
	}

	async getMerchant(req: { merchantID?: number; clientID?: number; groupID?: number }): Promise<IAPIResponse<IMerchantModel>> {
		if (!req) return { error: { code: -1, message: msg("invalidRequest") } };
		const merchantID = req.merchantID;

		if (merchantID === undefined) return { error: { code: -1, message: msg("invalidMerchantUid") } };

		if (merchantID === 0) {
			return {
				data: this.generateNewMerchant(req.clientID, req.groupID),
			};
		}

		//!TODO: cache?;

		const merchant = await GD.REQ_API.request({
			method: "merchants/get",
			headers: { Authorization: "Basic " + BanksService.ssid },
			data: { id: req.merchantID },
		});

		return merchant;
	}

	generateNewMerchant(client_id?: number, group_id?: number): IMerchantModel {
		const res: IMerchantModel = {
			client_id: client_id ?? 0,
			id: 0,
			name: "",
			url: "",
			billing_descriptor: "",
			collect_cardholder_data: "",
			created_at: "",
			description: "",
			group_id: group_id ?? 0,
			status: "created",
			terminal_id: 0,
			transfer_type: "",
			updated_at: "",
		};
		return res;
	}
}
